import axios from 'axios';
import store from '@/store';
import BaseClient from '../base-client';
import KnowledgeItem, { modelFactory } from './model';

export default class KnowledgeItemsClient extends BaseClient {
  constructor(options = {}) {
    super('search', {
      format: modelFactory.format,
      ...options,
    });
  }

  async searchByText(start, size, text) {
    try {
      const response = await this.request('get')({
        target: 'namedquery',
        entity: 'esearchKnowledgeItems',
        first: start,
        size,
        filters: {
          text,
        },
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async mostVisited(start, size, filters, order) {
    try {
      const response = await this.request('get')({
        target: 'namedquery',
        entity: 'mostVisitedKnowledgeItems',
        first: start,
        size,
        order,
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async ticketRelated(start, size, filters, order) {
    try {
      const response = await this.request('get')({
        target: 'namedquery',
        entity: 'ticketRelatedKnowledgeItems',
        first: start,
        size,
        order,
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  getDetail(id, baseUrl, publicRequest) {
    const cancelToken = axios.CancelToken.source();

    const req = this.request('get', id)({
      baseUrl,
    }, {
      path: `${publicRequest ? 'public/' : ''}knowledge-item`,
      cancelToken: cancelToken.token,
    });

    req.cancel = () => {
      req.cancelled = true;
      cancelToken.cancel('Operation was cancelled by user interaction');
    };

    req.format = this.format.bind(this);

    return req;
  }

  async hit(id) {
    try {
      const response = await this.request('put', `${id}/hit`)({}, {
        path: 'knowledge-item',
      });

      return (response.data || {}).HITS || 0;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  listFaqs = async ({ search = null, resourceCi }) => {
    const response = await this.request('get', 'faqs')({ search, resourceCi });
    return this.format(response);
  }

  searchKnowledgebyText = async ({ text }) => {
    const { isUserTecnical } = store.getters['session/user'];

    try {
      const response = await this.request('post')(
        {
          text,
          isUserTecnical,
        },
        { path: 'knowledge/search' },
      );

      return response.data;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }
}

export {
  KnowledgeItem,
};
